<template>
  <v-card>
    <v-card-title>Log Call</v-card-title>
    <v-card-text>
      <v-select v-model="stage" :items="orderedStages" @change="$emit('update-stage', $event, deal.id)" label="Stage" />
      <v-select
        v-model="logCallForm.callerId"
        :items="
          dealOwners.map((element) => {
            return { text: element.user.firstName + ' ' + element.user.lastName, value: element.user.id };
          })
        "
        label="Caller"
      />
      <v-select v-model="logCallForm.callOutcome" :items="callOutcomes" label="Call Outcome" />
      <v-select v-model="logCallForm.callTypeId" :items="callTypesFormatted" label="Call Type" />
      <v-textarea v-model="logCallForm.note" label="Note" />
      <div class="d-flex ">
        <date-time-picker
          ref="datePicker"
          class="mr-2"
          :show-time="false"
          :show-send-now="false"
          :set-min-date="false"
          @changed="callDate = $event"
        />

        <j-input-mask v-model="callTime" :value="callTime" :mask="['##:##']" masked placeholder="Time" suffix="HH:MM" />
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="mode === 'CREATE'"
        :disabled="!logCallFormValid"
        @click="$emit('insert-logged-call', logCallForm)"
        class="primary"
        >Log Call</v-btn
      >
      <v-btn v-else :disabled="!logCallFormValid" @click="$emit('edit-logged-call', logCallForm)" class="primary"
        >Edit Call</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import DateTimePicker from "@/components/shared/DateTimePicker";
import { decodeId } from "@/lib/string";
import JInputMask from "@/components/shared/inputs/JInputMask";

export default {
  name: "DealLogCall",
  components: {
    DateTimePicker,
    JInputMask,
  },
  props: {
    dealId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    callerId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    callOutcomes: {
      type: Array,
      required: true,
    },
    callTypes: {
      type: Array,
      required: true,
    },
    dealOwners: {
      type: Array,
      required: true,
    },
    stages: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      deal: null,
      stage: null,
      logCallForm: {
        callId: null,
        dealId: null,
        callerId: null,
        callOutcome: null,
        callTypeId: null,
        callTime: null,
        note: "",
      },
      callTime: null,
      callDate: null,
    };
  },
  watch: {
    callTime(value) {
      const dateTime = `${this.callDate} ${value}`;
      this.logCallForm.callTime = this.$moment(dateTime).toISOString();
    },
  },
  methods: {
    init(deal, callerId) {
      this.clear();
      this.deal = deal;
      this.stage = typeof deal.stage == "object" ? deal.stage.id : deal.stage;
      this.logCallForm.dealId = decodeId(deal.id);
      this.logCallForm.callerId = decodeId(callerId);
    },
    initEdit(deal, call) {
      this.deal = deal;
      this.stage = typeof deal.stage == "object" ? deal.stage.id : deal.stage;
      this.logCallForm.callId = call.id;
      this.logCallForm.callOutcome = call.callOutcome;
      this.logCallForm.callerId = call.caller.id;
      this.logCallForm.note = call.note;
      this.logCallForm.callTypeId = call.callType.id;
      this.callDate = this.$moment(call.callTime).format("YYYY-MM-DD");
      this.callTime = this.$moment(call.callTime).format("HH:mm");
      this.$refs.datePicker.setValues(call.callTime);
    },
    clear() {
      this.deal = null;
      this.stage = null;
      this.logCallForm.callId = null;
      this.logCallForm.callOutcome = null;
      this.logCallForm.callTypeId = null;
      this.logCallForm.callTime = null;
      this.logCallForm.note = "";
      this.callTime = "";
      this.callDate = "";
      this.$refs.datePicker.setValues(null);
    },
  },
  computed: {
    callTypesFormatted() {
      return this.callTypes.map((element) => {
        return {
          value: element.id,
          text: element.name,
        };
      });
    },
    logCallFormValid() {
      return (
        this.logCallForm.callerId != null && this.logCallForm.callTypeId != null && this.logCallForm.callOutcome != null
      );
    },
    mode() {
      return this.logCallForm.callId !== null ? "EDIT" : "CREATE";
    },
    orderedStages() {
      let stages = JSON.parse(JSON.stringify(this.stages));
      stages.sort((a, b) => (a.order > b.order ? 1 : -1));
      return stages.map((element) => {
        return {
          value: element.id,
          text: element.title,
        };
      });
    },
  },
};
</script>
